import CommunityPage from '.';

export const Community = () => <CommunityPage />;
